import { useRef, useEffect } from 'react';
import { createComponent, For, IntrinsicProps } from '@common/util/templateHelpers';
import { useNotifications } from '@common/hooks/useNotifications';
import Delete from '@common/components/controls/Delete';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

interface NotificationProps extends IntrinsicProps {
  warning?: boolean
  success?: boolean
  error?: boolean
  onDismiss: () => void
}

const notificationStates = [
  'warning',
  'success',
  'error'
];

const Notification = createComponent<NotificationProps>('Notification', 
  { classStates: notificationStates }, 
  function Notification ({ className, style }, props) {
    return (
      <div className={className} style={style} onClick={props.onDismiss}>
        {props.children}
      </div>
    );
  });
export default Notification;

/* --- */

interface NotificationsProps extends IntrinsicProps {
  topRight?: boolean
  middle?: boolean
  transitionName?: string
  transitionTimeout?: number
}

const notificationsStates = [
  'topRight',
  'middle'
];

export const Notifications = createComponent<NotificationsProps>('Notifications', 
  { classStates: notificationsStates }, 
  function Notifications ({ className, style }, props) {
    const { state, dismiss } = useNotifications();

    const updateIntervalRef = useRef(null);
    useEffect(() => {
      clearInterval(updateIntervalRef.current);

      const notificationUpdateInterval = 100;
      updateIntervalRef.current = setInterval(() => {
        const notification = state.notifications[ 0 ];
        if (!notification) return;

        notification.aliveFor -= notificationUpdateInterval;
        if (notification.aliveFor <= 0) {
          const index = state.notifications.indexOf(notification);
          dismiss(index);
        }
      }, notificationUpdateInterval);

      return () => {
        clearInterval(updateIntervalRef.current);
      };
    }, [ state, dismiss ]);

    return (
      <TransitionGroup className={className} style={style}>
        {
          For(state.notifications, ((item, i: number) => (
            <CSSTransition
              key={item.id}
              timeout={props.transitionTimeout || 400}
              classNames={`${props.transitionName || 'TxPopUpExitLeft400'}`}
              unmountOnExit
            >
              <Notification 
                success={item.status === 'success'}
                warning={item.status === 'warning'}
                error={item.status === 'error'}
                onDismiss={() => dismiss(i)}
              >
                {item.message}
                <Delete />
              </Notification>
            </CSSTransition>
          )), true)
        }
      </TransitionGroup>
    );
  });
